const WQInflowComparison = () => {
  /**
   * Utility function used to resize the sidebars after each chart render
   */
  const resizeSidebar = () => {
    const $sidebar = document.querySelector("#annual-report-nav-wrapper");
    const $leftSection = document.querySelector(
      ".annual-report-monitoring-left-section"
    );
    const body = document.body;
    const html = document.documentElement;

    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    $sidebar.style.height = `${height + 76}px`;
    $leftSection.style.height = `${height}px`;
  };

  const calcExtent = (data, scaleType, parameter) => {
    if (scaleType === "fixed") {
      if (parameter === 28) {
        return [0, 600];
      } else if (parameter === 29) {
        return [0, 4100];
      } else if (parameter === 30) {
        return [0, 350];
      }
      else if (parameter === 100138) {
        return [0, 120];
       }
    } else {
      return [0, d3.max(data.map((d) => d.rvalue))];
    }
  };

  /**
   * Utility function used to simplify the process of
   * creating an AJAX request
   * returns a promise
   * @param {number} location locationid to filter data on
   * @param {number} parameter parameterid to filter data on
   */
  const createRequest = (location, parameter, flowConditions) => {
    return jQuery.ajax({
      url: "/sites/all/scripts/view/wq-inflows-comparison.php",
      data: {
        activeYears: YearFilter.val(),
        location: location,
        parameter: parameter,
        flowConditions: flowConditions,
      },
    });
  };

  /**
   * Utility function used to transform stacked data into format required
   * for the multi-series bar chart.
   * returns an array of objects structured like
   * {
   *    month:  "Oct",
   *    values: {
   *      value: 12,
   *      category: 2019,
   *      month: "Oct",
   *      units: "ug/l",
   *      color: "#173042",
   *    }
   * }
   * @param {*} data
   */
  const transformData = (data) => {
    const colors = [
      "#F1A104",
      "#00743F",
      "#25B396",
      "#f10404",
      "#1E65A7",
      "#192E5B",
      "#F16604",
      "#70CED0",
      "#ED87AE",
    ];
    const colorAssignments = {
      2015: "#F1A104",
      2016: "#00743F",
      2017: "#25B396",
      2018: "#f10404",
      2019: "#1E65A7",
      2020: "#192E5B",
      2021: "#F16604",
      2022: "#70CED0",
      2023: "#ED87AE",
      2024: "#FF5733"
    };
    const uniqueYears = [...new Set(data.map((d) => d.year))];
    const uniqueMonths = [...new Set(data.map((d) => d.month))];
    const dataByMonth = uniqueMonths.map((month) => {
      return {
        month: month,
        values: data
          .filter((record) => record.month === month)
          .map((record) => ({
            value: record.rvalue,
            category: record.year,
            month: month,
            units: record.unit_name,
            color: colorAssignments[record.year],
          })),
      };
    });
    return dataByMonth;
  };

  /**
   * Configs for each graph that are used to simplify
   * the process of requesting data from the database
   * and creating a graph
   */
  const graphsConfig = [
    {
      selector: "#cc-10-tn-graph-section",
      location: 68,
      parameter: 29,
    },
    {
      selector: "#ct-2-tn-graph-section",
      location: 83,
      parameter: 29,
    },
    {
      selector: "#cc-10-tp-graph-section",
      location: 68,
      parameter: 28,
    },
    {
      selector: "#ct-2-tp-graph-section",
      location: 83,
      parameter: 28,
    },
    {
      selector: "#cc-10-ratio-graph-section",
      location: 68,
      parameter: 100138,
    },
    {
      selector: "#ct-2-ratio-graph-section",
      location: 83,
      parameter: 100138,
    },
    {
      selector: "#cc-10-tss-graph-section",
      location: 68,
      parameter: 30,
    },
    {
      selector: "#ct-2-tss-graph-section",
      location: 83,
      parameter: 30,
    },
  ];

  const FlowFilter = new Dropdown({
    parentContainer: "#flow-conditions",
    elementExists: false,
    label: "Flow Conditions",
    data: [
      { flow_conditions: 1, flow_conditions_desc: "Storm Flow" },
      { flow_conditions: 2, flow_conditions_desc: "Base Flow" },
      { flow_conditions: 3, flow_conditions_desc: "All Flows" },
    ],
    valueField: "flow_conditions",
    displayField: "flow_conditions_desc",
    onChange: () => {
      /**
       * Loop through each graph config
       * Once data is returned from the DB,
       * create a graph for the returned data
       */
      const graphPromises = graphsConfig.map((config) => {
        const promise = createRequest(
          config.location,
          config.parameter,
          FlowFilter.val()
        );
        jQuery.when(promise).done((data) => {
          const response = JSON.parse(data);
          const parsedData = transformData(response);
          const extent = calcExtent(
            response,
            scaleCheckbox.val(),
            config.parameter
          );
          const uniqueYears = [...new Set(response.map((d) => d.year))];
          createGraph(parsedData, config.selector, extent, uniqueYears);
        });
      });
    },
  })
    .buildDropdown()
    .val(2);

  const scaleCheckbox = new radioList({
    parentContainer: "#scales-checkbox-wrapper",
    label: "Scale Type",
    elementExists: false,
    displayInline: false,
    allowHTML: true,
    data: [
      { value: "fixed", display: "Fixed" },
      { value: "dynamic", display: "Dynamic" },
    ],

    onChange: () => {
      /**
       * Loop through each graph config
       * Once data is returned from the DB,
       * create a graph for the returned data
       */
      const graphPromises = graphsConfig.map((config) => {
        const promise = createRequest(
          config.location,
          config.parameter,
          FlowFilter.val()
        );
        jQuery.when(promise).done((data) => {
          const response = JSON.parse(data);
          const parsedData = transformData(response);
          const extent = calcExtent(
            response,
            scaleCheckbox.val(),
            config.parameter
          );
          const uniqueYears = [...new Set(response.map((d) => d.year))];
          createGraph(parsedData, config.selector, extent, uniqueYears);
        });
      });
    },
  }).buildList();

  // Create a chip filter for the graph year filters
  const YearFilter = new chipBag({
    parentContainer: "#year-filter",
    elementExists: false,
    label: "Year(s)",
    chipActiveColor: "#40b876",
    activeChipsValues: [2021, 2022, 2023, 2024],
    data: [
      { value: 2015, display: 2015 },
      { value: 2016, display: 2016 },
      { value: 2017, display: 2017 },
      { value: 2018, display: 2018 },
      { value: 2019, display: 2019 },
      { value: 2020, display: 2020 },
      { value: 2021, display: 2021 },
      { value: 2022, display: 2022 },
      { value: 2023, display: 2023 },
      { value: 2024, display: 2024 },
    ],
    onChange: () => {
      /**
       * Loop through each graph config
       * Once data is returned from the DB,
       * create a graph for the returned data
       */
      const graphPromises = graphsConfig.map((config) => {
        const promise = createRequest(
          config.location,
          config.parameter,
          FlowFilter.val()
        );
        jQuery.when(promise).done((data) => {
          const response = JSON.parse(data);
          const parsedData = transformData(response);
          const extent = calcExtent(
            response,
            scaleCheckbox.val(),
            config.parameter
          );
          const uniqueYears = [...new Set(response.map((d) => d.year))];
          createGraph(parsedData, config.selector, extent, uniqueYears);
        });
      });
    },
  });

  YearFilter.buildChips();

  let tooltipCard;

  /**
   * Utility function used to create a tooltip for the graph
   * @param {string} month month user is currently hovering over
   */
  const createTooltip = (data, month) => {
    if (month !== null || typeof month !== "undefined") {
      const tooltipData = data.filter((d) => d.month === month);

      if (document.querySelector(".tooltip-card-cc-10-tn") !== null) {
        document.querySelector(".tooltip-card-cc-10-tn").remove();
      }

      tooltipCard = d3
        .select("body")
        .append("div")
        .attr("class", "tooltip-card tooltip-card-cc-10-tn");

      let html = "";
      if (tooltipData.length > 0) {
        html = `<div class="ts-tooltip-title">${tooltipData[0].month}</div>`;
        tooltipData[0].values.forEach((d, i) => {
          const legendStyle = `background: ${d.color}`;
          html += `
            <div class="ts-tooltip-value-wrapper">
              <div class="ts-tooltip-legend" style="${legendStyle}"></div>
              <div class="ts-tooltip-value">${d.category}: ${d.value} ${d.units}</div>
            </div>`;
        });
      }

      tooltipCard.html(html);
      const tooltipWidth = Number(tooltipCard.style("width").slice(0, -2));
      const xPos =
        document.body.offsetWidth / event.pageX < 1.3
          ? event.pageX - (tooltipWidth + 15)
          : event.pageX + 15;

      tooltipCard
        .style("opacity", 1)
        .style("left", `${xPos}px`)
        .style("top", `${event.pageY - 15}px`);
    }
  };

  /**
   * Utility function used to hide tooltip when user
   * is not hovering over graph
   */
  const removeTooltip = () => {
    tooltipCard.style("opacity", 0);
  };

  /**
   * Function used to create the bar graph
   * @param {array} data data to plot
   * @param {string} selector css selector for the graph section
   * @param {array} extent array of min/max values for dataset
   */
  const createGraph = (data, selector, extent, uniqueSeries) => {
    // If graph already exists, remove it
    if (document.querySelector(`${selector} #graph svg`) !== null) {
      d3.select(`${selector} #graph svg`).remove();
    }

    // initialize the SVG
    const svg = d3.select(`${selector} #graph`).append("svg");
    const mobile = document.body.offsetWidth < 769;

    // Calculate SVG width and height
    let initWidth = d3.select(`${selector} #graph`).style("width");
    initWidth = parseInt(initWidth.substring(0, initWidth.length - 2));
    initWidth = mobile ? initWidth * 0.85 : initWidth * 0.95;
    const initHeight = initWidth * 0.45;

    // Assign SVG margin, width and height
    const margin = { top: 15, right: 15, bottom: 25, left: 55 };
    const width = initWidth - margin.left - margin.right;
    const height = initHeight - margin.top - margin.bottom;

    svg
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom);

    const g = svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // Define the scales for the x and y axes
    const x0 = d3.scaleBand().rangeRound([0, width]).paddingInner(0.1);
    const x1 = d3.scaleBand().padding(0.05);
    const y = d3.scaleLinear().rangeRound([height, 0]);

    // Calculate the domain for the x and y axes
    // i.e. the range of values for each axis
    // for the x axis this is a unique list of months
    // for the y axis this a min/max value
    x0.domain([
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ]);
    x1.domain(uniqueSeries).rangeRound([0, x0.bandwidth()]);
    y.domain(extent);

    // Append X axis to graph
    g.append("g")
      .attr("class", "axis axis--x")
        .style('font-size', '18px')
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x0));

    // append y axis to graph
    g.append("g")
      .attr("class", "axis axis--y")
        .style('font-size', '18px')
      .call(d3.axisLeft(y))
      .append("text")
      .attr("fill", "#000")
      .attr("y", 15)
      .attr("dy", "0.3em")
      .attr("transform", "rotate(-90)")
      .attr("text-anchor", "end")
      .style("font-size", "12px");

    // create a "group" rectangle for each month on the graph
    // a rectangle for each year/month combo will be appended
    // to this "group rectangle" in the next step
    const slice = g
      .selectAll(".slice")
      .data(data)
      .enter()
      .append("g")
      .attr("class", "g")
      .attr("transform", (d) => `translate(${x0(d.month)},0)`);

    // Append a bar for year/month combo
    // style the bar and add event listeners to display
    // the tooltip when a user hovers over the bar
    slice
      .selectAll("rect")
      .data((d) => d.values)
      .enter()
      .append("rect")
      .attr("width", x1.bandwidth())
      .attr("x", (d) => x1(d.category))
      .style("fill", "#333333")
      .style("fill", (d) => d.color)
      .attr("y", (d) => y(d.value))
      .attr("height", (d) => height - y(d.value))
      .on("mouseover", function (d, i) {
        createTooltip(data, d.month);
      })
      .on("mouseout", function (d, i) {
        removeTooltip(removeTooltip);
      });
  };

  /**
   * Loop through each graph config
   * Once data is returned from the DB,
   * create a graph for the returned data
   */
  const graphPromises = graphsConfig.map((config) => {
    const promise = createRequest(
      config.location,
      config.parameter,
      FlowFilter.val()
    );
    jQuery.when(promise).done((data) => {
      const response = JSON.parse(data);
      const parsedData = transformData(response);
      const extent = calcExtent(
        response,
        scaleCheckbox.val(),
        config.parameter
      );
      const uniqueYears = [...new Set(response.map((d) => d.year))];
      createGraph(parsedData, config.selector, extent, uniqueYears);
    });
  });
};
